import { render, staticRenderFns } from "./SolicitudBajaSim.vue?vue&type=template&id=3cf1a9b2&"
import script from "./SolicitudBajaSim.vue?vue&type=script&lang=ts&"
export * from "./SolicitudBajaSim.vue?vue&type=script&lang=ts&"
import style0 from "./SolicitudBajaSim.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports